// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.appendTag .el-input-group__append {\n  background-color: #409eff;\n  color: #fff;\n  border-color: #409eff;\n}\n", ""]);
// Exports
module.exports = exports;
